import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { injectIntl } from 'react-intl';
import { spring } from 'react-motion';

import ToastsPlace from 'modules/messageSystem/components/ToastsPlace';

const propTypes = {
  intl: PropTypes.object.isRequired,
  /** list of toast messages */
  toasts: PropTypes.arrayOf(PropTypes.shape({
    testId: PropTypes.string.isRequired,
    /** unique identifier of the message */
    id: PropTypes.string.isRequired,
    /** message in i18n format that will be displayed in toast */
    message: PropTypes.oneOfType([PropTypes.shape({
      id: PropTypes.string.isRequired,
      description: PropTypes.string,
      defaultMessage: PropTypes.string,
      values: PropTypes.object,
    }), PropTypes.string]),
    /** show close button */
    showClose: PropTypes.bool,
  })),
  /** @type string classname that will be added to container classes */
  containerClassName: PropTypes.string,
  /** define to true for hebrew language */
  rtl: PropTypes.bool,
  /** function to delete toast message by it's id */
  removeToast: PropTypes.func,
};
const defaultProps = {
  toasts: [],
  containerClassName: '',
  rtl: false,
  removeToast: noop,
};

const AppToastsPlace = ({ toasts, intl, ...props }) => {
  return (
    <ToastsPlace
      { ...props }
      toasts={ toasts.map(({ message, ...toast }) => {
        const { values } = message;

        if (values) {
          Object.entries(values).forEach(([key, value]) => {
            if (typeof value === 'object') {
              values[key] = intl.formatMessage(value);
            }
          });
        }

        return {
          ...toast,
          message: typeof message === 'string' ? message : intl.formatMessage(message, message.values),
        };
      }) }
      willLeave={ () => {
        return {
          x: spring(0, { stiffness: 140, damping: 14 }),
        };
      } }
      willEnter={ () => ({ x: 100 }) }
      styleModificator={ (items) => items.map((item) => ({
        key: item.id,
        data: item,
        style: {
          x: 100,
        },
      })) }
    />
  );
};

AppToastsPlace.propTypes = propTypes;
AppToastsPlace.defaultProps = defaultProps;

export default injectIntl(AppToastsPlace);
